<template>
  <v-layout>
    <v-chip
      v-if="typeof item === Boolean && !item && falseTitle"
      text-color="white"
      label
      small
      :color="'red'"
    >
      {{ falseTitle }}
    </v-chip>
    <v-chip
      v-if="typeof item === Boolean && item && trueTitle"
      text-color="white"
      label
      small
      :color="'green'"
    >
      {{ trueTitle }}
    </v-chip>
  </v-layout>
</template>
<script>
export default {
  props: ["item", "falseTitle", "trueTitle"],
};
</script>
